var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-treeview',{attrs:{"items":_vm.itemsTree,"item-key":"id","item-text":"text","open-all":""},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [_c('v-btn',{staticClass:"p-0 m-0",class:_vm.selected &&
        item.object[_vm.id] === _vm.selected[_vm.id] &&
        'blue--text',attrs:{"text":""},on:{"click":function($event){return _vm.onSelect(item)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"blue-grey darken-2"}},[_vm._v(" "+_vm._s(open && _vm.hasChildren(item) ? "mdi-folder-open" : "mdi-folder")+" ")]),_vm._v(" "+_vm._s(item['text'])+" ")],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }